import script from "./ProcedureTableHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcedureTableHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ProcedureTableHeader.vue?vue&type=style&index=0&id=14866387&lang=scss"

const __exports__ = script;

export default __exports__